const APPOINTMENT_REQUEST_BASE_PATH = '/patient/appointments/new'
const AVAILABILITY_REQUEST_PATH = '/patient/availability-request'
const BUDGET_REQUEST_PATH = '/patient/budget-request'

export default {
    methods: {
        goToAppointmentRequestRoute ({ profId, appointmentType, date, centerId, serviceId }) {
            const queryParams = {
                profId,
                appointmentType,
                date,
                centerId,
                serviceId
            }
            const filteredQueryParams = Object.fromEntries(
                Object.entries(queryParams).filter(([key, value]) => value !== null && value !== undefined && value !== '')
            )
            this.$router.push({ path: APPOINTMENT_REQUEST_BASE_PATH, query: filteredQueryParams })
        },
        goToAvailabilityRequestRoute ({ profId, type }) {
            const queryParams = {
                profId,
                type
            }
            this.$router.push({ path: AVAILABILITY_REQUEST_PATH, query: queryParams })
        },
        goToBudgetRequestRoute ({ profId }) {
            const queryParams = {
                profId
            }
            this.$router.push({ path: BUDGET_REQUEST_PATH, query: queryParams })
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/appointmentRequest.mixin.js